module.exports = __webpack_public_path__ + "img/card-input.78e28050.svg";